const DashboardCollaborationsPage = () => {
  return (
    <div>DashboardCollaborationsPage</div>
  );
};

export default DashboardCollaborationsPage;
